import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApi } from "../Services/apiService";

// Async thunk to fetch API data
export const fetchPermissionData = createAsyncThunk("api/fetchData", async () => {
  // const navigate=useNavigate()
  const response = await getApi('/user/permissions');
  
  if (!response || response.isNetworkError) {
    return null;
  }

  const data = response?.data; 
  if(response?.msg==="Your account is inactive"){
    localStorage.clear()
    window.location.href = '/inout/login'
  }
  return data;
});

const apiSlice = createSlice({
  name: "api",
  initialState: {
    data: null,
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissionData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPermissionData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchPermissionData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default apiSlice.reducer;
